import { render, staticRenderFns } from "./carriage-data.vue?vue&type=template&id=53409dd2&"
import script from "./carriage-data.vue?vue&type=script&lang=ts&"
export * from "./carriage-data.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53409dd2')) {
      api.createRecord('53409dd2', component.options)
    } else {
      api.reload('53409dd2', component.options)
    }
    module.hot.accept("./carriage-data.vue?vue&type=template&id=53409dd2&", function () {
      api.rerender('53409dd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/carriage-data/carriage-data.vue"
export default component.exports